import {pageLayout, getCurrentDevice} from './page-layout.mjs';

export function navigationPosition() {
  const replacements = [
    {
      selector: 'navigation-position-horizontal',
      regex: /cm4all-navigation-position-horizontal[^\s]+/,
      default: 'flex-start',
    },
    {
      selector: 'navigation-position-vertical',
      regex: /cm4all-navigation-position-vertical[^\s]+/,
      default: 'flex-start',
    },
    {
      selector: 'logo-position-horizontal',
      regex: /cm4all-navigation-logo-horizontal[^\s]+/,
      default: 'left',
    },
    {
      selector: 'logo-position-vertical',
      regex: /cm4all-navigation-logo-vertical[^\s]+/,
      default: 'top',
    },
  ];

  const bodySelector = window.getComputedStyle(document.body),
    THEME_HEADER = document.querySelector('.cm4all-theme-header'),
    prefix = 'cm4all';

  for (const element of replacements) {
    replaceElement(
      bodySelector,
      THEME_HEADER,
      element,
      element.selector,
      prefix
    );
  }
}

export function navigationPreset(newDevice) {
  const replacements = [
    {
      selector: 'desktop-logo-navigation-presets',
      regex: /cm4all-theme-[^\s]+-logo-navigation-presets[\S]+[^"]/g,
      default: 'logo-left-navigation-right',
    },
    {
      selector: 'tablet-landscape-logo-navigation-presets',
      regex: /cm4all-theme-[^\s]+-logo-navigation-presets[\S]+[^"]/g,
      default: 'logo-left-navigation-right',
    },
    {
      selector: 'tablet-logo-navigation-presets',
      regex: /cm4all-theme-[^\s]+-logo-navigation-presets[\S]+[^"]/g,
      default: 'logo-left-navigation-right',
    },
    {
      selector: 'mobile-logo-navigation-presets',
      regex: /cm4all-theme-[^\s]+-logo-navigation-presets[\S]+[^"]/g,
      default: 'logo-left-navigation-right',
    },
  ];
  const bodySelector = window.getComputedStyle(document.body),
    THEME_HEADER = document.querySelector('.cm4all-theme-header'),
    prefix = 'cm4all-theme';
  const device = newDevice || getCurrentDevice();

  const newSelector = `${device}-logo-navigation-presets`;
  const deviceReg = new RegExp(newSelector);
  for (const element of replacements) {
    if (element.selector.match(deviceReg)) {
      replaceElement(bodySelector, THEME_HEADER, element, newSelector, prefix);
    }
  }
  pageLayout(device);
  THEME_HEADER.classList.remove('cm4all-theme-header-hidden');
}

function replaceElement(
  bodySelector,
  themeHeader,
  element,
  addSelector,
  prefix
) {
  const currentValue = bodySelector
    .getPropertyValue(`--cm4all-theme-${element.selector}`)
    .trim()
    .replace(/['"]+/g, '');
  //const regex = new RegExp(element.regex, 'g');
  themeHeader.className = themeHeader.className.replace(element.regex, '');
  themeHeader.classList.add(
    `${prefix}-${addSelector}--${currentValue || element.default}`
  );
}
